import { motion } from "framer-motion";
import { MessageSquareQuote } from "lucide-react";
import Seo, { breadcrumbSchema } from "@/lib/seo";
import PageHero from "@/components/PageHero";
import { StaggerGroup, fadeUp } from "@/components/motion/Reveal";
import TestimonialCard from "@/components/TestimonialCard";
import CTASection from "@/components/CTASection";
import {
  CardGridSkeleton,
  EmptyState,
  QueryBoundary,
} from "@/components/states";
import { useTestimonials } from "@/hooks/content";
import { IMAGES } from "@/data/site";

export default function Testimonials() {
  const query = useTestimonials();

  return (
    <>
      <Seo
        title="Testimonials"
        description="Read what organisations across Singapore say about working with SKY Training & Consultancy for workplace safety, fire safety and training."
        path="/testimonials"
        schema={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Testimonials", path: "/testimonials" }])}
      />
      <PageHero
        eyebrow="Testimonials"
        title="What Our Clients Say"
        // TODO(handover): the seeded testimonials are placeholders with no
        // recognisable company names. Remove this disclosure once the client
        // has published their own testimonials from the admin panel.
        description="Demo testimonials are shown here until client-supplied testimonials are added. No recognisable company names are used."
        image={IMAGES.corporateProgramme}
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Testimonials", path: "/testimonials" }]}
      />

      <section className="section-pad">
        <div className="container-sky">
          <QueryBoundary
            query={query}
            skeleton={<CardGridSkeleton count={6} />}
            empty={
              <EmptyState
                icon={MessageSquareQuote}
                title="No testimonials published yet"
                description="Client testimonials will appear here once they are published from the admin panel."
              />
            }
          >
            {(items) => (
              <StaggerGroup className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {items.map((t) => (
                  <motion.div key={t.id} variants={fadeUp()}>
                    <TestimonialCard t={t} />
                  </motion.div>
                ))}
              </StaggerGroup>
            )}
          </QueryBoundary>
        </div>
      </section>

      <CTASection />
    </>
  );
}
